<template>
  <v-container
    id="calendar"
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <v-card class="pa-4">
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="form.date.from"
                label="Дата начала"
                type="date"
                @keyup.enter="load"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="form.date.to"
                label="Дата конца"
                type="date"
                @keyup.enter="load"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="form.phone"
                :disabled="view"
                label="Телефон"
                @keyup.enter="load"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="form.email"
                :disabled="view"
                label="E-mail"
                @keyup.enter="load"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-select
                v-model="form.type"
                :disabled="view"
                :items="select.type"
                label="Тип"
                @change="load"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-select
                v-model="form.state"
                :disabled="view"
                :items="select.state"
                @change="load"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.theme"
                :disabled="view"
                label="Тема"
                @keyup.enter="load"
              />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
              color="success"
              @click="show_create_event_dialog"
            >
              <span class="mx-3">
                Создать событие
              </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-tabs>
          <v-tab>Календарь</v-tab>
          <v-tab>Таблица</v-tab>
          <v-tab-item>
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>{{ now }}</v-toolbar-title>

                <calendar-btn @click="$refs.calendar.prev()">
                  <v-icon>mdi-chevron-left</v-icon>
                </calendar-btn>

                <calendar-btn @click="$refs.calendar.next()">
                  <v-icon>mdi-chevron-right</v-icon>
                </calendar-btn>
              </v-toolbar>

              <v-divider />
              <v-select
                v-model="type"
                :items="types"
                label="Выберите режим отображения"
              />
              <v-sheet
                height="600"
                flat
              >
                <v-calendar
                  ref="calendar"
                  v-model="calendar"
                  :weekdays="weekdays"
                  :events="events"
                  :type="type"
                  mode="stack"
                  locale="ru"
                  :now="today"
                  :value="today"
                  :event-color="getEventColor"
                  @click:event="showEvent"
                  event-more-text="Еще {0}"
                  @click:more="more_click"
                  @click:day="more_click"
                >
                </v-calendar>
              </v-sheet>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :items="events"
              :headers="table.headers"
              :footerProps="datatable_footer"
            >
             <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
              <template v-slot:item.state="{item}">
                {{ dict.state[item.state] }}
              </template>
              <template v-slot:item.type="{item}">
                {{ $store.state.dict.events[item.type].name }}
              </template>
              <template v-slot:item.contract="{item}">
                <span v-if="item.contract && item.contract_item"><a @click="$router.push('/contract/list?id=' + item.contract)">{{ format_contract(item.contract_item.number, item.contract_item.date) }}</a></span>
              </template>
              <template v-slot:item.client="{item}">
                <span v-if="item.client && item.client_item">{{ item.client_item.surname }} {{ item.client_item.name }} {{ item.client_item.patronymic }}</span>
              </template>
              <template v-slot:item.date="{item}">
                {{ item.start }}
              </template>
              <template v-slot:item.user="{item}">
                <span v-if="item.user && item.user_item">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  large
                  color="primary"
                  class="mr-2"
                  @click="changeEvent(item)"
                >
                  mdi-cog
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-dialog
      persistent
      v-model="dialog.event.show"
      scrollable
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load()"
      />
    </v-dialog>
        <v-dialog v-model="dialog.insurance.show" persistent>
      <InsuranceForm
        :create="dialog.insurance.create"
        :view="dialog.insurance.view"
        :change="dialog.insurance.change"
        :show="dialog.insurance.show"
        :vehicle="dialog.insurance.vehicle"
        :data="dialog.insurance.data"
        :old="dialog.insurance.old"
        @close="dialog.insurance.show = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
  // Components
  import { VBtn } from 'vuetify/lib'
  import EventForm from './EventForm'
  import moment from 'moment'
  export default {
    name: 'DashboardCalendar',

    components: {

      EventForm,
      CalendarBtn: {
        extends: VBtn,

        props: {
          color: {
            type: String,
            default: 'primary',
          },
          depressed: {
            type: Boolean,
            default: true,
          },
          minWidth: {
            type: Number,
            default: 0,
          },
          outlined: {
            type: Boolean,
            default: true,
          },
          rounded: {
            type: Boolean,
            default: true,
          },
        },

      },
    },

    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      view: false,
      table: {
        headers: [
          {
            text: 'Дата',
            value: 'date',
          },
          {
            text: 'Тип',
            value: 'type',
          },
          {
            text: 'Статус',
            value: 'state',
          },
          {
            text: 'Телефон',
            value: 'phone',
          },
          {
            text: 'Тема',
            value: 'theme',
          },
          {
            text: 'Договор',
            value: 'contract',
          },
          {
            text: 'Клиент',
            value: 'client',
          },
          {
            text: 'Исполнитель',
            value: 'user',
          },
          { text: '',
            value: 'action' },
        ],
      },
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      dialog: {
        event: {
          show: false,
          item: {},
        },
        insurance: {
          show: false,
          view: false,
          change: false,
          create: false,
          data: {},
          vehicle: "",
          old: ""
        }
      },
      now: moment().format('DD.MM.YYYY'),
      calendar: moment().format('YYYY-MM-DD'),
      today: moment().format('YYYY-MM-DD'),
      disabled: true,
      events: [

      ],
      dict: {
        state: {
          1: 'Новый',
          2: 'Завершен',
          3: 'Отменен',
        },
      },
      select: {
        state: [
          { value: 1, text: 'Новый' },
          { value: 2, text: 'Завершен' },
          { value: 3, text: 'Отменен' },
        ],
        type: [],
      },
      focus: '',
      type: 'month',
      types: [
        { value: 'month', text: 'Месяц' },
        { value: 'week', text: 'Неделя' },
        { value: 'day', text: 'День' },
      ],
      form: {
        date: {},
      },
    }),
    mounted: function () {
      this.form.date.from = moment().startOf('month').format('YYYY-MM-DD')
      this.form.date.to = moment().endOf('month').format('YYYY-MM-DD')
      this.load()
      for (let x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }
    },
    methods: {
      show_create_event_dialog: function() {
        this.dialog.event.data = {}
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      more_click: function(data) {
        console.log(data)
        this.type = 'day'
        this.calendar = data.date
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      interval_format: function (date) {
        console.log(date)
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      showEvent: function ({ nativeEvent, event }) {
        this.changeEvent(event)
      },
      changeEvent: function (event) {
        console.log(event)
        if (event.insurance_item) {
          this.dialog.insurance.data = event.insurance_item
          this.dialog.insurance.create = false
          this.dialog.insurance.change = false
          this.dialog.insurance.view = true
          this.dialog.insurance.show = true
        } else
        if (event.contract_data) {

        } else {
          this.dialog.event.data = event
          this.dialog.event.show = true
          this.dialog.event.create = false
          this.dialog.event.change = true
          this.dialog.event.view = false
        }
      },
      getEventColor (event) {
        return event.color
      },
      load: function () {
        this.axios.post('/api/event/list', this.form)
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                var event = this.$store.state.dict.events[result.data.data[x].type] || { color: 'black', name: '' }
                result.data.data[x].color = event.color
                result.data.data[x].start = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].name = event.name
                result.data.data[x].time = String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type == 0) result.data.data[x].type = 6
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
    },
    formatDate (a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
    },
  }
</script>

<style lang="sass">
  #calendar
    .v-calendar-weekly__day:last-child,
    .v-calendar-weekly__head-weekday:last-child
      border-right: none

    .v-calendar-weekly__week:last-child .v-calendar-weekly__day
      border-bottom: none
</style>
